// AI Generated Test
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MonModalService } from '@client/app/modules/modals/services/mon-modal/mon-modal.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { GlobalHelperService } from '@client/app/services/global-helper/global-helper.service';
import { ControlContainer, NgForm } from '@angular/forms';

interface Login {
    basic_auth?: {
        username: string;
        password: string;
        hosts: string[];
    };
}

@Component({
    selector: 'form-domain-scan-login-types-basic-auth',
    templateUrl: './form-domain-scan-login-basic-auth.component.html',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: false,
})
export class FormDomainScanLoginBasicAuthComponent implements OnInit {
    @Input() login: Login = {};
    @Input() url: string = '';
    @Output() whenHostValidityChange = new EventEmitter<{ valid: boolean }>();

    validHostname: boolean[] = [];

    constructor (
        private monModalService: MonModalService,
        private translateService: TranslateService,
        private globalHelperService: GlobalHelperService,
    ) {}

    ngOnInit (): void {
        this.login = this.login || {};
        this.validHostname = [];

        if (!this.isObject(this.login.basic_auth)) {
            this.login.basic_auth = {
                username: '',
                password: '',
                hosts: [],
            };
        }

        if (!Array.isArray(this.login.basic_auth.hosts)) {
            this.setupHostsArray();
        }

        this.calculateValidHost();
    }

    addHost (): void {
        if (this.login.basic_auth) {
            this.login.basic_auth.hosts.push('');
        }
        this.calculateValidHost();
    }

    removeHost (index: number): void {
        this.monModalService.confirm({
            message: this.translateService.getString('Are you sure you want to remove this host?'),
        }).then(() => {
            if (this.login.basic_auth) {
                this.login.basic_auth.hosts.splice(index, 1);
            }
            this.validHostname.splice(index, 1);
            this.calculateValidHost();
        }).catch(() => {
            // User cancelled, do nothing
        });
    }

    isValidHostname (hostnames: string[], index: number): void {
        this.validHostname[index] = Boolean(hostnames[index] && this.globalHelperService.isValidHostname(hostnames[index]));
        this.updateValidity();
    }

    trackByIndex (index: number): number {
        return index;
    }

    updateHost (index: number, event: Event): void {
        const value = (event.target as HTMLInputElement).value;
        if (this.login.basic_auth && this.login.basic_auth.hosts) {
            this.login.basic_auth.hosts[index] = value;
            this.isValidHostname(this.login.basic_auth.hosts, index);
        }
    }

    updateUsername (event: Event): void {
        const value = (event.target as HTMLInputElement).value;
        if (this.login.basic_auth) {
            this.login.basic_auth.username = value;
        }
    }

    updatePassword (event: Event): void {
        const value = (event.target as HTMLInputElement).value;
        if (this.login.basic_auth) {
            this.login.basic_auth.password = value;
        }
    }

    private isObject (val: unknown): val is object {
        return val !== null && typeof val === 'object' && !Array.isArray(val);
    }

    private setupHostsArray (): void {
        if (this.login.basic_auth) {
            this.login.basic_auth.hosts = [''];
            if (typeof this.url === 'string') {
                this.login.basic_auth.hosts = [this.url.replace(/(^\w+:|^)\/\//, '')];
            }
        }
    }

    private calculateValidHost (): void {
        if (this.login.basic_auth) {
            this.validHostname = this.login.basic_auth.hosts.map((hostName) =>
                Boolean(hostName && this.globalHelperService.isValidHostname(hostName)),
            );
        }
        this.updateValidity();
    }

    private updateValidity (): void {
        const invalid = this.validHostname.some(v => !v);
        this.whenHostValidityChange.emit({ valid: !invalid });
    }
}
